/** Typography for rendered prose only. Never use for identifiers or stored values. */
export function displayText(value: string): string {
  return value.replace(/\u2014/g, '-');
}
